import { LoaderFunction } from "react-router-dom";
import { getSearchQuery } from "../query.ts";
import { CompositeAsset } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import { searchStore } from "../../../../common/api/decimal/methods/searchStore.ts";
import { getAssetsByVbid } from "../../../../common/api/bridge/methods.ts";
import { getCountry } from "../../../../common/geoip.ts";
import { loadBrandOnce } from "../../../root/rootLoader.ts";

export interface SearchTitlesStoreData {
  totalItems: number;
  page: number;
  totalPages: number;
  results: CompositeAsset<"store" | "favorite">[];
}

async function filterResults(data?: CompositeAsset<"store" | "favorite">[]) {
  const hasResults = data?.length;
  if (hasResults) {
    // we don't want store results if already accessible via explore
    const vbids = data.map((asset) => asset.manageAsset.vbid);
    const bridgeData = await getAssetsByVbid(vbids);
    const bridgeVbids = bridgeData.content.map((asset) => asset.vbid);
    return data.filter(
      (asset) => !bridgeVbids.includes(asset.manageAsset.vbid)
    );
  }
  return [];
}

export const searchTitlesStoreLoader: LoaderFunction = async ({
  request,
}): Promise<SearchTitlesStoreData> => {
  const url = new URL(request.url);
  const query = getSearchQuery(url.searchParams);
  const [country, brand] = await Promise.all([getCountry(), loadBrandOnce()]);
  const page = Number(url.searchParams.get("page"));
  if (query && (country === "US" || brand.VirtualStore.companyId)) {
    const size = Number(url.searchParams.get("size"));
    const storeResp = await searchStore(query, size, page);
    const data = storeResp?.data;
    const meta = storeResp?.meta;
    const results = await filterResults(data);
    // Metadata known to be inconsistent with actual returned results
    const totalItems = meta?.page?.totals.results ?? 0;
    return Promise.resolve({
      totalItems,
      totalPages: meta?.page?.totals.pages ?? 0,
      page,
      results,
    });
  }
  return Promise.resolve({
    totalItems: 0,
    totalPages: 0,
    page: 0,
    results: [],
  });
};
